import React, { useState } from "react";
import { motion } from "framer-motion";
import { Link } from "gatsby";
const NavBar: React.FC = () => {
	const [navbarOpen, setNavbarOpen] = useState(false);
	const [navStatus, setNavStatus] = useState(false);
	const sidebar = {
		open: (height = 1000) => ({
			clipPath: `circle(${height * 2}px at 100% 0)`,
			transition: {
				type: "spring",
				stiffness: 50,
				restDelta: 5,
			},
		}),
		closed: {
			clipPath: "circle(0% at 100% 0)",
			transition: {
				type: "spring",
				stiffness: 400,
				damping: 40,
			},
		},
	};
	if (typeof document !== "undefined")
		navbarOpen
			? document.body.classList.add("overflow-hidden")
			: document.body.classList.remove("overflow-hidden");
	return (
		<>
			<div className='w-full hidden lg:block  text-left z-50'>
				<ul className='underline flex flex-shrink  justify-end'>
					<Link to='#portfolio' className='cursor-pointer'>
						<li className='p-5'>Portfolio</li>
					</Link>
					<Link to='#technologies' className='cursor-pointer'>
						<li className='p-5'>My Stacks</li>
					</Link>
					<Link to='#contact' className='cursor-pointer'>
						<li className='p-5'>Contact</li>
					</Link>
				</ul>
			</div>
			<div
				className='absolute lg:hidden top-0 right-0 pt-5 pr-8 z-30'
				onClick={() => {
					setNavbarOpen(!navbarOpen);
				}}
			>
				<div className={navbarOpen ? "open" : ""} id='nav-icon2'>
					<span></span>
					<span></span>
					<span></span>
					<span></span>
					<span></span>
					<span></span>
				</div>
			</div>
			<motion.div
				initial={false}
				onAnimationComplete={() => {
					setNavStatus(navbarOpen);
				}}
				animate={navbarOpen ? "open" : "closed"}
				className={`lg:hidden ${navbarOpen && "fixed"} ${
					!navbarOpen && !navStatus ? "hidden" : "fixed"
				}`}
			>
				<motion.div
					variants={sidebar}
					custom={
						typeof document !== "undefined"
							? window.innerHeight
							: 1000
					}
					className='bg-white grid justify-center w-screen h-screen  inset-0 '
				>
					<ul className='self-center bg-white h-48 text-lg underline'>
						<Link
							to='#portfolio'
							onClick={() => {
								setNavbarOpen(false);
							}}
							className='cursor-pointer'
						>
							<li className='my-5'>Portfolio</li>
						</Link>
						<Link
							to='#technologies'
							onClick={() => {
								setNavbarOpen(false);
							}}
							className='cursor-pointer'
						>
							<li className='my-5'>My Stacks</li>
						</Link>
						<Link
							to='#contact'
							onClick={() => {
								setNavbarOpen(false);
							}}
							className='cursor-pointer'
						>
							<li className='my-5'>Contact</li>
						</Link>
					</ul>
				</motion.div>
			</motion.div>
		</>
	);
};

export default NavBar;
